import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useSalonPublicTheme } from '../../../../context/SalonPublicThemeContext';
import SalonPublicStyleScope from '../../salonPublicAppearance/SalonPublicStyleScope';


const LOCATION_VARIANTS = new Set(['map', 'contact', 'split', 'compact']);

const SalonTemplateContactLocation = ({
  data,
  variant = 'map',
  visible = true,
  mode = 'public',
}) => {
  const { t } = useTranslation();
  const { tokens: theme } = useSalonPublicTheme();
  const locationVariant = LOCATION_VARIANTS.has(variant) ? variant : 'map';
  const preview = mode === 'preview';

  if (!visible || !data || (!data.address && data.latitude == null && data.longitude == null)) {
    return null;
  }

  const latitude = Number(data.latitude);
  const longitude = Number(data.longitude);
  const query = encodeURIComponent(data.address || data.name || `${latitude},${longitude}`);
  const src = Number.isFinite(latitude) && Number.isFinite(longitude)
    ? `https://www.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`
    : `https://www.google.com/maps?q=${query}&z=15&output=embed`;

  return (
    <SalonPublicStyleScope
      sectionKey="location"
      data-testid="salon-section-location"
      data-salon-template-block="contact-location"
      data-variant={locationVariant}
      sx={{ mt: 8 }}
    >
      <Box sx={{ mb: 3 }}>
        <Typography
          component="h2"
          data-salon-text-role="title"
          variant="h5"
          sx={{ color: theme.colors.gray[700], fontWeight: 600, mb: 1, fontSize: '1.5rem', letterSpacing: '0.025em' }}
        >
          {t('landing_salon_details.our_location')}
        </Typography>
        <Box sx={{ width: 60, height: 3, bgcolor: theme.colors.secondary[400], borderRadius: 2 }} />
      </Box>
      <Box
        data-salon-text-role="content"
        sx={{
          backgroundColor: theme.colors.background.primary,
          borderRadius: 3,
          border: `1px solid ${theme.colors.border.light}`,
          overflow: 'hidden',
          width: '100%',
        }}
      >
        <Box sx={{ p: 2 }}>
          {data.name ? <Typography sx={{ fontWeight: 700, color: theme.colors.gray[700] }}>{data.name}</Typography> : null}
          {data.address ? <Typography sx={{ color: theme.colors.gray[500], mt: 0.5 }}>{data.address}</Typography> : null}
        </Box>
        <Box sx={{ width: '100%', height: 280, bgcolor: theme.colors.gray[100] }}>
          <iframe
            title={data.name || t('landing_salon_details.our_location')}
            src={src}
            aria-disabled={String(preview)}
            tabIndex={preview ? -1 : 0}
            width="100%"
            height="100%"
            style={{ border: 0, pointerEvents: preview ? 'none' : 'auto' }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </Box>
      </Box>
    </SalonPublicStyleScope>
  );
};

export default SalonTemplateContactLocation;
